import React, { ReactElement } from 'react';

import { hasAlreadySeen } from '~/src/common/add-to-calendar';

import { LazyAddToCalendarPromoBody } from './LazyAddToCalendarPromo';

export const AddToCalendarPromo: React.FC<{ children: ReactElement }> = props => {
  const hasSeen = hasAlreadySeen();
  if (hasSeen) {
    return <>{props.children}</>;
  }
  return <LazyAddToCalendarPromoBody {...props} />;
};
